import type { ApiISODateTimeString } from '#/api/types/ApiTypedDate';
import { Text } from '#/components/Text/Text';
import { useIsClient } from '#/hooks/useIsClient';
import { useI18n } from '#/i18n/hooks/useI18n';
import {
  distanceInWordsToNow,
  formatIdealistDateTime,
  shortDateTime,
} from '#/utils/date';

type Props = {
  listingFirstPublished: ApiISODateTimeString;
  isNew: boolean;
};

export function ListingViewHeaderPublishedTag({
  listingFirstPublished,
  isNew,
}: Props) {
  const { i18n, locale } = useI18n();
  const isClient = useIsClient();

  return (
    <>
      {isNew && (
        <div>
          <Text
            fontWeight="semiBold"
            color="mediumContentGrey"
            borderBottom="4px solid"
            borderColor="brandYellow"
            display="inline-block"
            lineHeight="6px"
            ml="0px"
            mr="12px"
            p="0px"
          >
            {i18n('New')}
          </Text>
        </div>
      )}

      <Text
        display="inline-block"
        color={isNew ? 'accessibleYellow' : 'darkContentGrey'}
      >
        {
          /* TRANSLATORS: Listing page - time published */
          i18n('Published %(timeAgo)s', {
            timeAgo: isClient
              ? distanceInWordsToNow({
                  date: listingFirstPublished,
                  locale,
                })
              : shortDateTime({
                  date: formatIdealistDateTime(new Date(listingFirstPublished)),
                  locale,
                }),
          })
        }
      </Text>
    </>
  );
}
